/**
 * Local Dependencies
 */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import faqs from './routes/faqs';
import recovery from './routes/recovery';
// Blocks
// import './blocks/accordion/block'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,

  // FAQs
  faqs,
  recovery,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
